const _ = require('lodash');
const operationsFactory = require('../../ToolsOperationsFactory');
const CONST = require('../../constants');

class OperationsFromDocumentConverter {
  convert(documentPassed, options = {}) {
    const defOptions = {};

    const { forEachOperation } = {
      ...defOptions,
      ...options,
    };

    // prevent mutation
    const document = { ...documentPassed };

    // #region  pages
    const documentPagesArray = this._extractPagesArray(document);

    const [pagesIterationOrder, pagesOperation] = (() => {
      if (!documentPagesArray.length) return [];

      return [
        this._getPagesOrder(documentPagesArray),
        operationsFactory.pages(documentPagesArray),
      ];
    })();

    const templateOperationsIndex = {};
    // #endregion

    // #region template
    const templatedOperationsArray = this._convertFromTemplate(
      document,
      pagesIterationOrder,
      (operation, innerOptions) => {
        const { flatArrayIndex } = innerOptions;
        // check fieldId
        const fieldId = _.get(operation, 'properties.template.id', false);

        templateOperationsIndex[fieldId] = flatArrayIndex;

        // Неведомый зверь - пока не удалил для ревью
        //       if ([TYPE.SIGNATURE, TYPE.CHECKMARK].includes(operationTemplate.properties.type)) {
        //         operationTemplate.properties.master = origin === 'auto'
        //           ? Boolean(operationTemplate.properties.master)
        //           : true;
        //       }

        if (typeof forEachOperation === 'function') {
          return forEachOperation(operation, innerOptions);
        }

        return operation;
      }
    );
    // #endregion

    // #region content
    const contentFreeToolOperations = this._convertFromContent(document, pagesIterationOrder, (operationContent) => {
      const linkId = _.get(operationContent, 'properties.content.linkId', false);
      const templateOperationIndex = linkId ? templateOperationsIndex[linkId] : false;

      // return to contentFreeToolOperations
      if (templateOperationIndex === false) return operationContent;

      // process as linked content operation
      const content = _.get(operationContent, 'properties.content', false);

      if (content) {
        _.set(
          templatedOperationsArray[templateOperationIndex],
          'properties.content',
          content
        );
      }
      // skip for contentFreeToolOperations
      return false;
    });
    // #endregion

    // comments
    const commentOperations = this._convertFromComments(document);

    // attributes
    const attributesOperations = this._convertFromAttributes(document);

    // resolution operation
    const resolutionOperation = this._getResolutionOperation(document);

    const contentLayerArray = [
      ...templatedOperationsArray,
      ...contentFreeToolOperations,
    ];

    return {
      ...(pagesOperation ? { pages: [pagesOperation] } : { pages: [] }),
      content: contentLayerArray.length ? contentLayerArray : [],
      comments: commentOperations.length ? commentOperations : [],
      attributes: attributesOperations.length ? attributesOperations : [],
      resolution: resolutionOperation ? [resolutionOperation] : [],
    };
  }

  _createFlatOperationsFromPagedEntity(entityWithPages, pagesOrder, forEachFn) {
    if (!pagesOrder) pagesOrder = entityWithPages.map((i, ind) => ind);
    // case when pages section not passed at all
    if (!pagesOrder.length) pagesOrder = entityWithPages.map((e, i) => i);

    const resultArray = pagesOrder.reduce((acc, pageId) => {
      const page = entityWithPages[pageId];

      if (!page) {
        return acc;
      }

      return page.reduce((accInner, element, indexOnPage) => {
        const flatArrayIndex = accInner.length;
        const operation = forEachFn(element, { pageId, indexOnPage, flatArrayIndex });

        if (!operation) {
          return accInner;
        }

        accInner.push(operation);
        return accInner;
      }, acc);
    }, []);

    return resultArray;
  }

  _getPagesOrder(pages) {
    return pages.reduce((order, p) => {
      if (p.visible) {
        order.push(+p.source);
      }
      return order;
    }, []);
  }

  _extractPagesArray(doc) {
    return _.get(doc, 'pages.list', false);
  }

  _extractTemplatesArray(doc) {
    return _.get(doc, 'fields.list', []);
  }

  _extractContentArray(doc) {
    return _.get(doc, 'content.list', []);
  }

  _extractCommentsArray(doc) {
    return _.get(doc, 'comments.list', []);
  }

  _extractAttributesHash(doc) {
    return _.get(doc, 'attributes.list', {});
  }

  _convertFromTemplate(document, pageIterateOrder, onEachFn) {
    const documentTemplate = this._extractTemplatesArray(document);

    if (!documentTemplate.length) return [];

    let _orderMax = 0;

    try {
      return this._createFlatOperationsFromPagedEntity(
        documentTemplate,
        pageIterateOrder,
        (template, { pageId, indexOnPage, flatArrayIndex }) => {
          const { type = 'text' } = template;

          const operationTemplate = operationsFactory.template({ type, template, pageId });

          const opTpl = operationTemplate.properties.template;

          opTpl.required = !!opTpl.required;

          if (opTpl.type === CONST.TYPE.SIGNATURE && opTpl.subType === 'initials') {
            opTpl.restrictSubTypes = ['text'];
          }

          if (typeof opTpl.order === 'undefined' || opTpl.order <= _orderMax) opTpl.order = ++_orderMax;
          else _orderMax = Math.max(_orderMax, opTpl.order);

          return onEachFn(
            operationTemplate,
            {
              template, pageId, indexOnPage, flatArrayIndex,
            }
          );
        }
      );
    } catch (err) {
      throw new Error(`Template failed :: ${err.message}`);
    }
  }

  _convertFromContent(document, pageIterateOrder, onEachFn) {
    const documentContent = this._extractContentArray(document);

    if (!documentContent.length) return [];

    try {
      return this._createFlatOperationsFromPagedEntity(
        documentContent,
        pageIterateOrder,
        (element, { pageId, indexOnPage, flatArrayIndex }) => {
          const operationContent = operationsFactory.content({
            content: element,
            pageId,
          });

          return onEachFn(
            operationContent,
            {
              element, pageId, indexOnPage, flatArrayIndex,
            }
          );
        }
      );
    } catch (err) {
      throw new Error(`Content failed :: ${err.message}`);
    }
  }

  _convertFromComments(document, pageIterateOrder) {
    const comments = this._extractCommentsArray(document);

    if (!comments.length) return [];

    try {
      return this._createFlatOperationsFromPagedEntity(
        comments, pageIterateOrder,
        (comment, { pageId }) => operationsFactory.comment(comment, pageId)
      );
    } catch (err) {
      throw new Error(`Content failed :: ${err.message}`);
    }
  }

  _convertFromAttributes(document) {
    const attributes = this._extractAttributesHash(document);

    if (!attributes) return [];

    return Object.keys(attributes).map((attributeKey) => {
      const operation = operationsFactory.attribute(attributeKey, attributes[attributeKey].content);

      return operation;
    });
  }

  _getResolutionOperation(document) {
    const metadata = ['content', 'fields', 'pages', 'attributes'].reduce((acc, key) => {
      if (acc.dpi) return acc;
      return _.get(document, `${key}.metadata`, {});
    }, {});

    // if (!metadata.dpi) return false;

    return operationsFactory.create(
      CONST.GROUP.DOCUMENT, CONST.TYPE.RESOLUTION, '',
      { pdfDPI: 72, contentDPI: metadata.dpi || 72 }
    );
  }
}

module.exports = OperationsFromDocumentConverter;
